var map = {
	"./book-s.png": 1696,
	"./book.png": 539,
	"./class-s.png": 1697,
	"./class.png": 540,
	"./coin-s.png": 1698,
	"./coin.png": 309,
	"./donation-s.png": 1699,
	"./donation.png": 1700,
	"./invite-s.png": 1701,
	"./invite.png": 1702,
	"./money-s.png": 1703,
	"./money.png": 1704,
	"./reading-off.png": 1705,
	"./reading-s.png": 1706,
	"./reading.png": 1707,
	"./reviews.png": 1708,
	"./school-s.png": 1709,
	"./school.png": 1710,
	"./student-s.png": 1711,
	"./student.png": 1712,
	"./writing-s.png": 1713,
	"./writing.png": 1714
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 694;



//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons .\.png*
// module id = 694
// module chunks = 0